import { useState, useEffect } from "react";

function useTabState<T extends string>(localStorageKey: string, initialTab: T) {
  // Initialize state with localStorage value if it exists, otherwise use initialTab
  const [tab, setTab] = useState<T>(() => {
    if (typeof window === "undefined") return initialTab;
    const saved = localStorage.getItem(localStorageKey);
    return (saved as T) ?? initialTab;
  });

  // Sync tab changes to localStorage
  useEffect(() => {
    localStorage.setItem(localStorageKey, tab as string);
  }, [localStorageKey, tab]);

  return [tab, setTab] as const;
}


export default useTabState;
